import React from "react";

const Delisting = () => {
  const delistingNotices = [
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-08-22",
      date: "2025-08-20",
    },
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-08-15",
      date: "2025-08-13",
    },
    {
      title:
        "Tillionx Futures Will Delist USDⓈ-M DEFIUSDT and MEMEFI Perpetual Contracts (2025-08-11)",
      date: "2025-08-06",
    },
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-08-08",
      date: "2025-08-06",
    },
    {
      title: "Notice of Removal of Margin Trading Pairs - 2025-08-08",
      date: "2025-08-04",
    },
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-08-01",
      date: "2025-07-30",
    },
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-07-25",
      date: "2025-07-23",
    },
    {
      title: "Notice of Removal of Spot Trading Pairs - 2025-07-04",
      date: "2025-07-02",
    },
  ];
  return (
    <div>
      <div className="my-16 rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans">
       <nav className="flex items-center text-sm  mb-6">
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Delisting</span>
        </nav>
        <h2 className="text-xl font-bold mb-6">Delisting</h2>

        {/* Notices List */}
        {delistingNotices.map((item, index) => (
          <div
            key={index}
            className="py-4 border-b border-gray-200 last:border-b-0"
          >
            <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
              {item.title}
            </h3>
            <p className="text-sm mt-1">{item.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Delisting;
